import { logIfDevelopment } from '@lib/utils/logging';

export const googleSignout = (): void => {
  const signoutUrl =
    'https://' +
    process.env.NEXT_PUBLIC_COGNITO_DOMAIN +
    '/logout?client_id=' +
    process.env.NEXT_PUBLIC_CLIENT_ID +
    '&logout_uri=' +
    process.env.NEXT_PUBLIC_OAUTH_REDIRECT_SIGN_OUT;

  fetch(signoutUrl).catch((err) => {
    logIfDevelopment({ err });
  });
};
